//#region 后端返回实体
/** 文保单位坐标实体 */
export class UnitPositionMapData {
    [key: string]: any
    /** 文保单位Id */
    UnitId: number
    /** 是否是组成部分 */
    IsPart: boolean
    /** 坐标类型 
     * 1:文保单位坐标
     * 2:监控地带
     * 3:保护范围
     * 4:巡查点配置
     * 5:重点保护范围
     * 6:碑文
     * 7:其他
     * 101:打卡点
     * 201:巡查轨迹
    */
    Category: number
    /** 坐标 标题 */
    Title: string
    /** 坐标 精度 */
    Longitude: number
    /** 坐标 纬度 */
    Latitude: number
    constructor() {
        this.UnitId = 0
        this.IsPart = false
        this.Category = 0
        this.Title = ''
        this.Longitude = 0
        this.Latitude = 0
    }
}
//#endregion
/** 图标类型 */
export type MapIconType = '' | 'UnitDefault' | 'MonitorArea' | 'ProtectArea'
    | 'CruisePoint' | 'KeyProtectArea' | 'Epigraphy' | 'CheckPoint' | 'CruiseTrack' | 'VideoPoint'

type MapPolyType = '' | 'polygon' | 'polyline'
//#region 文保单位在百度地图中展示用实体
/** 地图折线、多边形等实体 */
export class MapPolyData {
    [key: string]: any
    /** 类型：多边形 polygon，polyline  */
    Type: MapPolyType
    /** 坐标组 */
    Coords: MapCoordData[]
    /** 边框颜色 */
    StrokeColor: string
    constructor() {
        this.Type = ''
        this.Coords = []
        this.StrokeColor = ''
    }
}
/** 百度地图 覆盖物 数据结构 */
export class MapMarkData {
    [key: string]: any
    /** 展示图标 */
    IconUrl: string
    /** 标题 */
    Title: string
    /** 标志 经纬度*/
    Coord: MapCoordData
    /** 标志中的Label的内容，可自定义html */
    Content: string
    Data?: any
    constructor() {
        this.IconUrl = ''
        this.Title = ''
        this.Coord = new MapCoordData()
        this.Content = ''
        this.Data = null
    }
}
/** 百度地图坐标字段，不可更改 */
export class MapCoordData {
    [key: string]: any
    lng: number
    lat: number
    constructor() {
        this.lng = 0
        this.lat = 0
    }
}
/** 打卡点实体 */
export class CheckPointData extends MapCoordData {
    [key: string]: any
    pointId: number
    pointName: string
    constructor() {
        super()
        this.pointId = 0
        this.pointName = ''
    }
}
//#endregion